import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = ({ onNavigate }) => {
  const tabs = [
  { id: 'home', label: 'Home' },
  { id: 'team', label: 'Team' },
  { id: 'services', label: 'Services' },
  { id: 'knowledge', label: 'Knowledge Bank' },
  { id: 'query', label: 'Query' },
  { id: 'careers', label: 'Careers' },
  { id: 'contact', label: 'Contact Us' }];


  return (
    <footer className="bg-[#0D1B2A] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          {/* Left Section - Firm Details */}
          <div>
            <h3 className="font-eras !text-3xl !italic mb-2 text-[#C9A84C]">
              AGDG & Associates
            </h3>
            <p className="text-sm mb-2 font-dmsans">Chartered Accountants</p>
            <p className="text-sm mb-2 font-dmsans">ICAI Firm Reg. No.: 012691C</p>
            <p className="text-sm italic font-dmsans text-gray-400">
              Jaipur | Dubai
            </p>
          </div>

          {/* Center Section - Quick Links */}
          <div>
            <h4 className="text-lg font-serif font-bold text-[#C9A84C] mb-4">Quick Links</h4>
            <div className="grid grid-cols-2 gap-2">
              {tabs.map((tab) =>
              <button
                key={tab.id}
                onClick={() => onNavigate(tab.id)}
                className="text-left text-sm font-sans hover:text-[#C9A84C] transition-colors">

                  {tab.label}
                </button>
              )}
            </div>
          </div>

          {/* Right Section - Contact Info */}
          <div>
            <h4 className="text-lg font-serif font-bold text-[#C9A84C] mb-4">Contact Information</h4>
            <div className="space-y-3 font-sans text-sm">
              <div className="flex items-start gap-3">
                <MapPin className="text-[#C9A84C] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p className="font-semibold text-white">India Office:</p>
                  <p>R-8A, 2nd Floor, Yudhishthir Marg</p>
                  <p>C-Scheme, Jaipur – 302006</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="text-[#C9A84C] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p>+91-9314922355</p>
                  <p>+91-9799494483</p>
                  <p>+91-9799494481</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="text-[#C9A84C] flex-shrink-0 mt-1" size={18} />
                <div>
                  <p>auditors@agdgassociates.com</p>
                
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 mb-6"></div>

        {/* Bottom Section - Disclaimer & Copyright */}
        <div className="space-y-4">
          <p className="text-xs font-sans text-gray-400 leading-relaxed">
            <strong className="text-white">ICAI Compliance Disclaimer:</strong> This website is published in 
            accordance with the guidelines issued by the Institute of Chartered Accountants of India (ICAI). 
            The information on this website is for general awareness only and does not constitute professional 
            advice or solicitation for professional work. No person should act on the basis of any information 
            contained herein without obtaining appropriate professional advice. AGDG & Associates, Chartered 
            Accountants assumes no responsibility for any decisions or actions taken based on the information 
            provided on this website.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs font-sans">
            <p className="text-gray-400">
              © {new Date().getFullYear()} AGDG & Associates, Chartered Accountants. All rights reserved.
            </p>
            <p className="text-gray-500">
              Designed for AGDG & Associates
            </p>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;